import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { PAGE_META } from "@/landing/lib/page-meta";
import { getPricingData } from "@/landing/lib/pricing-api";
import { CliModelPricing } from "@/landing/pricing/CliModelPricing";

export const Route = createFileRoute("/_landing/models")({
  component: ModelsPage,
  head: () => ({
    meta: [
      { title: PAGE_META["/models"].title },
      { name: "description", content: PAGE_META["/models"].description },
      { property: "og:title", content: PAGE_META["/models"].title },
      { property: "og:description", content: PAGE_META["/models"].description },
      {
        property: "og:image",
        content: `${BASE_URL}/og/models.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/models"].title },
      {
        name: "twitter:description",
        content: PAGE_META["/models"].description,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/models.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/models` }],
  }),
});

function ModelsPage() {
  const data = getPricingData();
  return <CliModelPricing data={data} />;
}
